import React from 'react';
import { Link } from 'react-router-dom';
import './BlogList.scss';
import Seo, { breadcrumbSchema } from '../../Seo/Seo';

// grab every .js/.jsx file in BlogPostsContent
const req = require.context(
  '../BlogPostsContent',  // relative path from this file
  false,                  // do not recurse into subfolders
  /\.jsx?$/               // match .js and .jsx
);

// pull out the default export from each module
const blogPosts = req
  .keys()
  .map((key) => req(key).default)
  // ensure we only pick modules that have the shape we expect:
  .filter((post) => post && post.id && post.date)
  // sort by date descending:
  .sort((a, b) => new Date(b.date) - new Date(a.date));

const BlogList = () => {
  const [latestPost, ...otherPosts] = blogPosts;

  return (
    <div className="blog-list page-top-settings primary">
      <Seo
        title="Laundry Detergent Sheets Insights"
        description="Read B2B laundry detergent sheet insights on private label sourcing, bulk cartons, refill shops, packaging, PVA, and wholesale strategy."
        path="/blogs"
        schema={breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Blogs", path: "/blogs" }])}
      />
      <header>
        <h1>Laundry Detergent Sheets Insights</h1>
        <h2 className="page-title">B2B Sourcing, Packaging, and Private Label Guides</h2>
        <p className="blog-page-intro">
          Resources for brands, refill shops, wholesalers, distributors, and e-commerce teams evaluating detergent sheets as a private label or bulk product.
        </p>
      </header>

      {/* Latest */}
      {latestPost && (
        <div className="blog-latest">
          <img
            src={latestPost.imageUrl1}
            alt={latestPost.title}
            className="blog-image"
          />
          <div className="blog-details">
            <Link to={`/blogs/${latestPost.id}`} className="blog-title">
              {latestPost.title}
            </Link>
            <p className="blog-date">{latestPost.date}</p>
            <p className="mb-5">{latestPost.summary}</p>
            <Link to={`/blogs/${latestPost.id}`} className="blog-read-more">
              Read Article
            </Link>
          </div>
        </div>
      )}

      {/* Other posts */}
      <div className="blog-cards">
        {otherPosts.map((post) => (
          <div key={post.id} className="blog-card">
            <img
              src={post.imageUrl1}
              alt={post.title}
              className="blog-image"
            />
            <div className="blog-details">
              <Link to={`/blogs/${post.id}`} className="blog-title">
                {post.title}
              </Link>
              <p className="blog-date">{post.date}</p>
              <p className="blog-summary-text">{post.summary}</p>
              <Link to={`/blogs/${post.id}`} className="blog-read-more">
                Read Article
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogList;
